
import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Mail, Calendar } from 'lucide-react';

const ContactSection = () => {
  const navigate = useNavigate();
  
  const handleCalendlyClick = () => {
    navigate('/contact', { state: { defaultTab: 'calendar' } });
  };
  
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <div className="bg-gradient-to-br from-morgenBlue to-morgenViolet rounded-2xl p-10 text-white shadow-xl overflow-hidden relative">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-white opacity-10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
            
            <div className="relative z-10">
              <h2 className="text-3xl font-bold mb-4">Get in Touch</h2>
              <p className="text-xl mb-8 max-w-2xl">
                We're seeking aligned partners for early pilots and adoption. 
                Let's design the next layer of care together.
              </p>
              
              <div className="flex flex-col md:flex-row items-center gap-4 mb-8">
                <Button
                  onClick={() => navigate('/contact')} 
                  variant="secondary"
                  size="lg"
                  className="bg-white text-morgenBlue hover:bg-gray-100 w-full md:w-auto"
                >
                  Contact Us
                </Button>
                
                <Button
                  onClick={handleCalendlyClick}
                  variant="outline"
                  size="lg"
                  className="border-white text-white hover:bg-white/10 w-full md:w-auto"
                >
                  <Calendar className="mr-2 h-5 w-5" />
                  Schedule Meeting
                </Button>
                
                <a 
                  href="mailto:info@morgenhealth.com" 
                  className="flex items-center gap-2 text-white hover:underline w-full md:w-auto justify-center md:justify-start"
                >
                  <Mail className="h-5 w-5" />
                  info@morgenhealth.com
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;
